import _ from 'lodash';

import { PRODUCER_CREATE, PRODUCER_DELETE, PRODUCER_LIST, PRODUCER_READ, PRODUCER_UPDATE } from '@/store/actions/producer';
import producerApi from '@/api/producer';

/* eslint-disable camelcase */


const state = {
  producers: [],

  producer: {
    producer_id: null,
    name: null,
    address: {
      address: null,
      zipCode: null,
      city: null,
      country: null
    },
    phone_number: null,
    contact_name: null,
    email: null,
    type: null,
    contract: null,
    /* BILLING */
    company_name: null,
    legal_form: null,
    siret: null,
    vat_number: null,
    ape_code: null,
    iban: null,
    bic: null,
    devise: null,
    website_url: null,
    lang: null,
    /* USER */
    username: null,
    password: null
  },
  defaultItem: {
    producer_id: null,
    name: null,
    address: {
      address: null,
      zipCode: null,
      city: null,
      country: null
    },
    phone_number: null,
    contact_name: null,
    email: null,
    type: null,
    contract: null,
    /* BILLING */
    company_name: null,
    legal_form: null,
    siret: null,
    vat_number: null,
    ape_code: null,
    iban: null,
    bic: null,
    devise: null,
    website_url: null,
    lang: null,
    /* USER */
    username: null,
    password: null
  }
};

const getters = {
  producerById: (state) => (id) => {
    return state.producers.find(p => p.producer_id === id);
  }
};

const actions = {
  async [PRODUCER_LIST] ({ commit }) {
    commit(PRODUCER_LIST, await producerApi.getProducers());
  },

  async [PRODUCER_CREATE] ({ commit }, data) {
    commit(PRODUCER_CREATE, await producerApi.createProducer(data));
  },

  async [PRODUCER_READ] ({ commit }, id) {
    if (state.producer.producer_id !== id) {
      commit(PRODUCER_READ, { producer_id: id });
      commit(PRODUCER_READ, await producerApi.getProducer(id));
    }
  },

  async [PRODUCER_UPDATE] ({ commit }, data) {
    commit(PRODUCER_UPDATE, Object.assign({}, data, await producerApi.updateProducer(data)));
  },

  async [PRODUCER_DELETE] ({ commit }, id) {
    await producerApi.deleteProducer(id);
    commit(PRODUCER_DELETE, id);
  }
};

const mutations = {
  [PRODUCER_LIST] (state, producers) {
    state.producers = producers;
  },

  [PRODUCER_CREATE] (state, producer) {
    state.producers.push(producer);
  },

  [PRODUCER_READ] (state, producer) {
    state.producer = _.merge({}, state.defaultItem, producer);
  },

  [PRODUCER_UPDATE] (state, producer) {
    const idx = state.producers.findIndex(elt => elt.producer_id === producer.producer_id);
    state.producers.splice(idx, 1, producer);
  },

  [PRODUCER_DELETE] (state, id) {
    const idx = state.producers.findIndex(elt => elt.producer_id === id);
    if (idx !== -1) {
      state.producers.splice(idx, 1);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
